// extracted by mini-css-extract-plugin
export default {"signup-form":"Signup_signup-form__ENycE","container":"Signup_container__kiK3D"};